export default __webpack_public_path__ + "static/media/carousel4.13a8ec31.jpg";